<template>
  <NavBar />
  <main class="main-content" :class="{ 'auth-page-bg': isAuthPage }">
    <router-view />
  </main>
  <footer class="footer">
    <div class="footer-content">
      <router-link to="/impressum" class="footer-link">Impressum</router-link>
    </div>
  </footer>
</template>

<script>
// hauptkomponente der anwendung
// enthält die navbar, den router-view für die seiten und den footer
// importiere die navbar-komponente
import NavBar from './components/NavBar.vue'
import { computed, watch, onUnmounted } from 'vue'
import { useRoute } from 'vue-router'

// hauptkomponente der anwendung
// enthält die navbar, den router-view für die seiten und den footer
export default {
  name: 'App',
  components: {
    NavBar // registriere die navbar-komponente
  },
  setup() {
    const route = useRoute()
    const isAuthPage = computed(() => {
      return route.path === '/signin' || route.path === '/register'
    })
    
    // setze/entferne klasse auf html und body für auth-seiten
    const updateBodyClass = (isAuth) => {
      if (isAuth) {
        document.documentElement.classList.add('auth-page-active')
        document.body.classList.add('auth-page-active')
      } else {
        document.documentElement.classList.remove('auth-page-active')
        document.body.classList.remove('auth-page-active')
      }
    }
    
    // beobachte änderungen an isAuthPage
    watch(isAuthPage, (newValue) => {
      updateBodyClass(newValue)
    }, { immediate: true })
    
    // cleanup beim unmount
    onUnmounted(() => {
      document.documentElement.classList.remove('auth-page-active')
      document.body.classList.remove('auth-page-active')
    })
    
    return {
      isAuthPage
    }
  }
}
</script>

<style>
:root {
  --primary: #234998;   /* Dunkelblau */
  --secondary: #0063AD; /* Mittelblau */
  --tertiary: #6EC7DB;  /* Hellblau */
  --page-bg: #FFFFFF;   /* Seitenhintergrund */
}
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

html {
  scrollbar-gutter: stable;
  overflow-y: auto;
}

html.auth-page-active {
  overflow-y: auto;
}

body.auth-page-active {
  overflow-y: auto;
}

body {
  margin: 0;
  padding: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background: var(--page-bg, #FFFFFF);
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* Einheitliche Überschriften */
h1, h2, h3, h4, h5, h6 {
  color: var(--primary, #234998);
  margin: 0;
  padding: 0;
  line-height: 1.2;
}

h1 {
  font-size: 32px;
  font-weight: 800;
  letter-spacing: -0.2px;
}

h2 {
  font-size: 32px;
  font-weight: 700;
}

h3 {
  font-size: 20px;
  font-weight: 700;
}

.main-content {
  flex: 1;
}

.main-content.auth-page-bg {
  background: #f7f9fc;
  min-height: calc(100vh - 70px - 80px);
}

.footer {
  background: #fff;
  border-top: 1px solid rgba(0,0,0,0.06);
  padding: 24px 16px;
  margin-top: auto;
}

.footer-content {
  max-width: 1400px;
  margin: 0 auto;
  text-align: center;
}

.footer-link {
  color: #667085;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.2s ease;
}

.footer-link:hover {
  color: var(--secondary, #0063AD);
}
</style>